import { RequestOptions } from "axios-types";
import { ApiEndpoints } from "configs";
import { IGetAllSchedulesQuery, IGetAllSchedulesResponse } from "types/schedule";
import ExecuteAsync from "utils/api-client";
import createQueryParams from "utils/create-query-params";

const executeGetAllSchedulesRequest = (
    query: IGetAllSchedulesQuery,
    options?: RequestOptions,
): Promise<IGetAllSchedulesResponse | undefined> => {
    // The schedules endpoint returns its paginated payload ({ data, total, nextStartKey, ... })
    // at the response root, not wrapped in ExecuteAsync's usual { status, data, messages }
    // envelope. ExecuteAsync's default unwrap would strip total/nextStartKey and hand back
    // just the row array, so this request opts out of that unwrap via `skipEnvelopeUnwrap`.
    return ExecuteAsync<undefined, IGetAllSchedulesResponse>({
        baseURL: ApiEndpoints.BaseUrlEndpoint,
        method: "GET",
        url: `/admin/schedules${createQueryParams({ ...query })}`,
        signal: options?.signal,
        disableNotification: options?.disableNotification,
        skipEnvelopeUnwrap: true,
    });
};

export default executeGetAllSchedulesRequest;
